<template>
  <el-dialog
    title="修改服务费率"
    :visible.sync="innerVisible"
    width="520px"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <el-form ref="formRef" :model="formData" :rules="formRules" label-width="120px" size="small">
      <el-form-item label="当前服务费率：">
        {{ Number(currentRate || 0) }}%
      </el-form-item>
      <el-form-item label="新服务费率" prop="serviceFeeRate">
        <el-input
          :value="formData.serviceFeeRate"
          placeholder="请输入"
          style="width: 220px"
          @input="onRateInput"
        >
          <template slot="append">%</template>
        </el-input>
        <div class="rate-tip">0 ≤ 服务费率 ≤ 10 的整数</div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="innerVisible = false">取消</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="onSubmit">
        提交
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { editJointPartnerStoreServiceFeeAPI } from "../api";

export default {
  name: "EditJointPartnerServiceFeeDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: [Number, String],
      default: null,
    },
    currentRate: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      innerVisible: false,
      submitting: false,
      formData: {
        serviceFeeRate: "",
      },
      formRules: {
        serviceFeeRate: [
          { required: true, message: "请输入新服务费率", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!/^(10|[0-9])$/.test(String(value || ""))) {
                callback(new Error("请输入0-10之间的整数"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.innerVisible = val;
        if (val) {
          this.formData.serviceFeeRate = "";
          this.$nextTick(() => {
            this.$refs.formRef?.clearValidate();
          });
        }
      },
    },
    innerVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    onRateInput(value) {
      const digitText = String(value || "").replace(/\D/g, "");
      if (!digitText) {
        this.formData.serviceFeeRate = "";
        return;
      }
      let n = parseInt(digitText, 10);
      if (Number.isNaN(n)) {
        this.formData.serviceFeeRate = "";
        return;
      }
      if (n > 10) n = 10;
      if (n < 0) n = 0;
      this.formData.serviceFeeRate = String(n);
    },
    onClose() {
      this.$refs.formRef?.resetFields();
      this.formData.serviceFeeRate = "";
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.submitting = true;
        try {
          await editJointPartnerStoreServiceFeeAPI({
            id: Number(this.rowId),
            serviceRate: Number(this.formData.serviceFeeRate),
          });
          this.$message.success("保存成功");
          this.innerVisible = false;
          this.$emit("success");
        } catch {
          // 错误提示由 @/http/axios.js 的 http 统一弹出
        } finally {
          this.submitting = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.rate-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #e6a23c;
  line-height: 1.4;
}
</style>
